import { CashSessionStatus } from '@/@types/cash-management';
import { TableRowAction, TableRowActions } from '@/components/common/Table';
import { useCan } from '@/modules/core/hooks/useCan';
import {
  Assignment,
  Lock,
  AssignmentTurnedIn,
  Undo,
  Visibility,
} from '@mui/icons-material';

export interface CashSessionsTableActionsProps {
  id: string;
  status: CashSessionStatus;
  // eslint-disable-next-line no-unused-vars
  onViewCashSession: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onStartReconciliation: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onEditDeclarations: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onCloseCashSession: (id: string) => void;
  // eslint-disable-next-line no-unused-vars
  onRevertCashSession: (id: string) => void;
}

export function CashSessionsTableActions({
  id,
  status,
  onViewCashSession,
  onStartReconciliation,
  onEditDeclarations,
  onCloseCashSession,
  onRevertCashSession,
}: CashSessionsTableActionsProps) {
  const canViewDetails = useCan({ permissions: ['cash_sessions_details'] });
  const canReconcile = useCan({
    permissions: ['cash_sessions_reconciliation'],
  });
  const canClose = useCan({ permissions: ['cash_sessions_close'] });
  const canRevert = useCan({ permissions: ['cash_sessions_revert_status'] });

  let primaryAction: TableRowAction | undefined;
  const secondaryActions: TableRowAction[] = [];

  if (status === 'OPEN' && canViewDetails) {
    primaryAction = {
      title: 'Visualizar',
      icon: Visibility,
      onClick: () => onViewCashSession(id),
    };
  }

  if (status === 'OPEN' && canReconcile) {
    secondaryActions.push({
      title: 'Conferir',
      icon: AssignmentTurnedIn,
      onClick: () => onStartReconciliation(id),
    });
  }

  if (status === 'RECONCILIATION' && canReconcile) {
    primaryAction = {
      title: 'Conferência',
      icon: Assignment,
      onClick: () => onEditDeclarations(id),
    };
  }

  if (status === 'RECONCILIATION' && canViewDetails) {
    secondaryActions.push({
      title: 'Visualizar',
      icon: Visibility,
      onClick: () => onViewCashSession(id),
    });
  }

  if (status === 'RECONCILIATION' && canClose) {
    secondaryActions.push({
      title: 'Fechar',
      icon: Lock,
      onClick: () => onCloseCashSession(id),
    });
  }

  if (status === 'RECONCILIATION' && canRevert) {
    secondaryActions.push({
      title: 'Voltar Status',
      icon: Undo,
      onClick: () => onRevertCashSession(id),
    });
  }

  if (status === 'CLOSED' && canViewDetails) {
    primaryAction = {
      title: 'Visualizar',
      icon: Visibility,
      onClick: () => onViewCashSession(id),
    };
  }

  if (status === 'CLOSED' && canRevert) {
    secondaryActions.push({
      title: 'Voltar Status',
      icon: Undo,
      onClick: () => onRevertCashSession(id),
    });
  }

  return (
    <TableRowActions
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
    />
  );
}
